export default "__VITE_ASSET__95147b63__"